/**
 * getParams
 *
 * Will malfunction if url string is not properly URI encoded.  Please make sure to URI encode your strings if you are manually doing this with javascript.
 */

const getParams = function(url) {
  const params = {};
  const parser = document.createElement("a");
  parser.href = url;
  const query = parser.search.substring(1);

  if (query.length > 0) {
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");

      if (pair[1]) {
        let value = pair[1];
        value = value.replace(/\+/g, " ");
        value = decodeURIComponent(value);

        params[pair[0]] = value;
      } else {
        console.warn(
          `getParams.js: query object was parsed but key ${
            pair[0]
          } has no value.  Check for extra reserved characters in query string (such as amperstands)`
        );
      }
    }
  }

  return params;
};

function applySpaces(string) {
  return string
    .split("")
    .map(letter => (letter === "+" ? " " : letter))
    .join("");
}

export { getParams, applySpaces };
